// Profile avatar resolution. When a user has no uploaded photo we show a local
// Pawseum asset instead of Auth0's initials/gravatar placeholder or an external
// avatar service. Seeded by user id so it stays stable across renders.

const LOCAL_AVATARS = [
  "/assets/logos/PawseumProfile.webp",
  "/assets/DEFAULT.webp",
  "/assets/DEFAULT_GATO.webp",
] as const;

function hashSeed(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (Math.imul(h, 31) + seed.charCodeAt(i)) >>> 0;
  }
  return h;
}

/** A random (non-initials) avatar URL, stable for a given seed (e.g. user id). */
export function randomAvatarUrl(seed?: string | null): string {
  const token = seed ? hashSeed(seed) : Math.floor(Math.random() * 1e9);
  return LOCAL_AVATARS[token % LOCAL_AVATARS.length];
}

// Auth0 renders "initials" as a gravatar/auth0/ui-avatars default image; treat
// those as "no real photo" so we fall through to a random animal instead.
function isInitialsPlaceholder(url: string): boolean {
  return /cdn\.auth0\.com\/avatars|gravatar\.com\/avatar|ui-avatars\.com/i.test(
    url,
  );
}

/** Resolve the avatar to show: uploaded photo > real social photo > local fallback. */
export function resolveProfileAvatar({
  dbAvatarUrl,
  authPicture,
  seed,
}: {
  dbAvatarUrl?: string | null;
  authPicture?: string | null;
  seed?: string | null;
}): string {
  if (dbAvatarUrl) return dbAvatarUrl;
  if (authPicture && !isInitialsPlaceholder(authPicture)) return authPicture;
  return randomAvatarUrl(seed);
}
